import { Component, inject, OnInit } from '@angular/core';
import { ProgramsService } from '../../services/programs.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Program } from '../../models/programs.model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-programs',
  imports: [RouterLink, DatePipe],
  templateUrl: './programs.component.html',
  styles: `
    .card {
      --bs-card-border-radius: 0;
      --bs-card-inner-border-radius: 0;
    }
  `
})
export class ProgramsComponent implements OnInit {
  programs?: Program[] = [];
  loading = true;
  params = {
    type: ''
  };

  private programsService = inject(ProgramsService);
  private route = inject(ActivatedRoute);

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.params.type = params.get('type')!;
      this.getPrograms();
    });
  }

  getPrograms() {
    this.loading = true;
    this.programs = [];

    this.programsService.getAll(this.params).subscribe((programs) => {
      this.programs = programs;
      this.loading = false;
    });
  }
}
